import { ProForm } from "@ant-design/pro-components";
import { Image } from "antd";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { CustomButton, CustomCard, CustomInput, toast } from "../../../../../../components";
import { useModal } from "../../../../../../context/ModalContext";
import { channelEnum } from "../../../../../../enumerations/channelEnum";
import { apiCodeEnum } from "../../../../../../enumerations/signInUpEnum";
import { moneyFormat } from "../../../../../../plugins/numberFormat";
import {
  checkInputHasNull,
  envChangeType,
  middleEllipsis,
  reset,
} from "../../../../../../plugins/utils";
import { usePostWithdraw } from "../../../../hooks/index.hook";
import AmountArea from "../../../AmountArea";
import ChannelRadio from "../../../ChannelRadio";
import SettingArea from "../../../SettingArea";
import styles from "./style.module.scss";
import "./style.scss";

const Withdraw = ({ data }) => {
  const { t } = useTranslation();
  const formRef = useRef();
  const navigate = useNavigate();
  const { openTipsModal } = useModal();
  const [fee, setFee] = useState(NaN);
  const [actualMoney, setActualMoney] = useState("0");
  const [methods, setMethods] = useState([]);
  const [methodsValue, setMethodsValue] = useState();
  const [disabled, setDisabled] = useState(true);
  const [targetChain, setTargetChain] = useState({});

  const { mutate: Withdraw, isLoading } = usePostWithdraw();

  const settingEnum = [
    {
      label: t("label.conversionRate"),
      value: t("wallet.recharge.rate", {
        rate: targetChain?.ratio,
        currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
        transformCurrency: targetChain?.name,
      }),
    },
    {
      label: t("label.receivable"),
      value: moneyFormat(actualMoney * targetChain?.ratio, 6, 6),
    },
    // {
    //   label: t("label.handlingFee"),
    //   value: `${data?.with_free || 0}%`,
    // },
  ];

  const handleChangeAmount = (value = 0) => {
    const newFee = value * (data?.with_free / 100);
    setFee(newFee);
    setActualMoney(formRef?.current?.getFieldValue("number") - newFee);
    formRef.current.setFieldsValue({ fee: newFee });
    checkInputHasNull(formRef, setDisabled);
  };

  const handleFinish = () => {
    if (!data?.digital_address) {
      openTipsModal({
        body: t("wallet.withdraw.noAddress"),
        needCancel: true,
        onOk: () => navigate("/user/withdrawAddress?tab=withdrawAddress"),
      });
    } else {
      // openTipsModal({
      //   body: t("wallet.withdraw.confirm", { account: targetChain?.address }),
      //   isHtml: true,
      //   needCancel: true,
      //   onOk: handleConfirm,
      // });
      handleConfirm();
    }
  };

  const handleConfirm = () => {
    const params = formRef.current.getFieldsValue();
    const form = new FormData();
    form.append("chain", targetChain?.name);
    form.append("address", targetChain?.address);
    form.append("number", params.number);
    form.append("password", params.password);

    Withdraw(
      {
        params: form,
      },
      {
        onSuccess: (success) => {
          const { code, msg } = success?.data;
          if (code === apiCodeEnum.ERROR) {
            openTipsModal({
              body: msg,
            });
            return;
          }
          toast({ content: msg, type: "success" });
          reset(formRef);
          navigate("/user/withdraw/record?tab=withdraw&radioValue=record");
        },
        onError: () => {},
      },
    );
  };

  useEffect(() => {
    if (!data) return;
    console.log(data);
    let newMethods = [];
    const { coins } = data;
    data.wallet_address.map((item, index) => {
      if (!item?.digital_chain && !item?.digital_address) return null;
      const target = coins.filter((coin) => coin.name === item.digital_chain);
      newMethods.push({
        value: index.toString(),
        text: (
          <div className="content-container">
            <div className="title">
              {target ? (
                target[0].logo ? (
                  <Image
                    src={envChangeType("REACT_APP_MOBILE_URL") + target[0].logo}
                    alt="logo"
                    preview={false}
                    className="img"
                  />
                ) : (
                  <img src={channelEnum[item.digital_chain]?.src} alt="logo" className="img" />
                )
              ) : null}
              <div>{item?.digital_chain}</div>
            </div>
            <div className="sub-title">
              {middleEllipsis({
                inputString: item?.digital_address,
                minStringLength: 7,
                firstLetterLength: 4,
                secondLetterLength: 4,
                symbol: "****",
              })}
            </div>
          </div>
        ),
        ratio: target ? target[0].ratio : "0",
        address: item?.digital_address,
        name: item?.digital_chain,
      });
      return item;
    });
    setMethodsValue(newMethods.length > 0 ? newMethods[0].value : "");
    newMethods.push({
      value: "Add",
      text: t("wallet.withdraw.addAddress"),
      ratio: "0",
      address: "",
      name: "Add",
    });
    setMethods(newMethods);
  }, [data, t]);

  useEffect(() => {
    if (methods.length <= 0 || !methodsValue) return;
    const newTargetChain = methods.filter((item) => item.value === methodsValue)[0];
    setTargetChain(newTargetChain);
  }, [methods, methodsValue]);

  return (
    <div className={styles.withdraw}>
      <AmountArea money={data?.user_blance || 0} />
      <CustomCard>
        <ProForm
          formRef={formRef}
          onFinish={handleFinish}
          submitter={false}
          className="withdraw-from"
        >
          <ChannelRadio
            methods={methods}
            methodsValue={methodsValue}
            setMethodsValue={setMethodsValue}
          />
          <div className="input-container">
            <CustomInput
              label={t("label.withdrawAmount")}
              name="number"
              placeholder={t("normal.pleaseEnter", { label: t("label.withdrawAmount") })}
              type="number"
              onChange={handleChangeAmount}
            />
            {/* <CustomInput
              label={t("label.fee")}
              name="fee"
              readOnly={true}
              value={`${moneyFormat(fee)} ${t(
                `currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`,
              )}`}
            /> */}
            <CustomInput
              name="password"
              label={t("label.paymentPassword")}
              placeholder={t("normal.pleaseEnter.your", { label: t("label.paymentPassword") })}
              onChange={() => checkInputHasNull(formRef, setDisabled)}
              type="password"
            />
            <CustomButton
              buttonStyle={`${styles.customButtonStyle}`}
              type={"submit"}
              loading={isLoading}
              disabled={disabled}
            >
              {t("normal.submit").toUpperCase()}
            </CustomButton>
          </div>
          <div className={styles.actualPayment}>
            <div className={styles.text}>{t("wallet.withdraw.actualPayment")}</div>
            <div className={styles.money}>
              {t(`currency.symbol.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`) +
                " " +
                moneyFormat(actualMoney)}
            </div>
          </div>
          <SettingArea settingEnum={settingEnum} />
          <div
            className={styles.hint}
            dangerouslySetInnerHTML={{
              __html: t("wallet.withdraw.hint", {
                currency: t(`currency.unit.${envChangeType("REACT_APP_DEFAULT_CURRENCY")}`),
                lowMoney: data?.withdraw_lowmoney,
                start: data?.start_time,
                end: data?.end_time,
                fee: data?.with_free,
              }),
            }}
          />
        </ProForm>
      </CustomCard>
    </div>
  );
};

export default Withdraw;
